import * as React from "react"
import Popover from "@mui/material/Popover"
import { Box, IconButton } from "@mui/material"
import { FaFont } from "react-icons/fa"
import { styles } from "./KeyPicker.styles"
import { VirtualKeyboard } from "components/UI"
import { useAuthContext } from "contexts/AuthContext"

export default function KeyPicker({ onKeySelected }) {
  const { userData } = useAuthContext()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? "simple-popover" : undefined

  const onKeyPress = (key) => {
    if (onKeySelected) {
      onKeySelected(key)
    }
    handleClose()
  }

  return (
    <Box sx={styles.accent}>
      <IconButton aria-describedby={id} onClick={handleClick}>
        <FaFont />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Box sx={styles.main}>
          <VirtualKeyboard
            key={"teacher-message-keyboard"}
            fullKeyboard={false}
            useOneLine
            templateId={userData?.language}
            keyStyle={styles.key}
            onKeyPress={onKeyPress}
            listenKeys={false}
          />
        </Box>
      </Popover>
    </Box>
  )
}
